module.exports = __webpack_public_path__ + "static/media/sign-up-background.561ad28c.png";